import { render } from "./RunHistory.vue?vue&type=template&id=a97bbcca&scoped=true"
import script from "./RunHistory.vue?vue&type=script&lang=js"
export * from "./RunHistory.vue?vue&type=script&lang=js"

import "./RunHistory.vue?vue&type=style&index=0&id=a97bbcca&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a97bbcca"]])

export default __exports__